/**
 * Runs the given tasks with a fixed number of parallel workers.
 * Stops dequeuing (but does not cancel in-flight tasks) once the signal aborts.
 * Tasks are expected to handle their own errors; a rejection stops only its worker's queue.
 */
export async function runPooled(
  tasks: readonly (() => Promise<void>)[],
  concurrency: number,
  abortSignal?: AbortSignal
): Promise<void> {
  let next = 0;
  const worker = async () => {
    while (next < tasks.length && !abortSignal?.aborted) {
      const task = tasks[next++];
      await task();
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(concurrency, tasks.length) }, () => worker())
  );
}
